import { Theme } from "common";

const defaultDrawerWidth = 400;

export const pageStyles = {
  pageContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
  },
  pageMain: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },

  pageMainShift: {
    width: `calc(100% - ${defaultDrawerWidth}px)`,
    marginLeft: defaultDrawerWidth,
    transition: Theme.transitions.create(["margin", "width"], {
      easing: Theme.transitions.easing.easeOut,
      duration: Theme.transitions.duration.enteringScreen,
    }),
  },
};
